import { render, staticRenderFns } from "./BankResponse.vue?vue&type=template&id=5c64883e&scoped=true&"
import script from "./BankResponse.vue?vue&type=script&lang=js&"
export * from "./BankResponse.vue?vue&type=script&lang=js&"
import style0 from "./BankResponse.vue?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/css/success.css?vue&type=style&index=1&id=5c64883e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c64883e",
  null
  
)

export default component.exports